import { useExpenseTypeActions } from "../actions/expenseTypeActions"
import { useExpenseTypeBuilders } from "../builders/expenseTypeBuilders"
import { useExpenseTypeLoaders } from "../loaders/expenseTypeLoaders"

export const useExpenseTypeService = () => {
    const { buildExpenseType } = useExpenseTypeBuilders()
    
    const expenseTypeLoaders = useExpenseTypeLoaders()

    const { saveExpenseType } = useExpenseTypeActions()

    const archiveExpenseType = async (expenseTypeId: string) => {
        const { loadExpenseType } = expenseTypeLoaders()
        const expenseType = await loadExpenseType(expenseTypeId, true)
        const archivedExpenseType = buildExpenseType({
            ...expenseType,
            archived: true
        })
        return saveExpenseType(archivedExpenseType)
    }

    return {
        archiveExpenseType
    }
}
